<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="blue-grey lighten-5"
    >
      <v-tab key="map-addon-units">Addons</v-tab>
      <v-tab key="map-addon-groups">Groups</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item key="map-addon-units">
        <r-map-addon-page/>
      </v-tab-item>
      <v-tab-item key="map-addon-groups">
        <r-map-addon-group-page/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import RMapAddonPage from "@/modules/redactor/views/map-addon/addon/r-map-addon-page.vue";
import RMapAddonGroupPage from "@/modules/redactor/views/map-addon/group/r-map-addon-group-page.vue";

export default {
  name: "r-map-addon-config-page",
  components: {RMapAddonGroupPage, RMapAddonPage},
  data: () => ({
    tab: null
  })
}

</script>